export const baselineAmenityKeywords = [
  // Connectivity / tech
  'wifi',
  'wi-fi',
  'wireless internet',
  'wireless internet connection',
  'wireless internet connection in public areas',
  'internet access',
  'high speed internet',
  'high speed internet access',
  'high speed wireless',
  'wired internet access',
  'digital tv service',

  // TV / media
  'television',
  'color television',
  'remote control television',
  'tv',
  'satellite television',
  'premium movie channels',
  'pay per view movies on tv',
  'video on demand',
  'vcr player',
  'vcr movies',
  'dvd player',
  'dvd movies',
  'bluray player',
  'smart tv',
  'streaming services',

  // Climate / basic comfort
  'air conditioning',
  'air-conditioning',
  'air conditioning individually controlled in room',
  'self-controlled heating/cooling system',
  'a/c',
  'ceiling fan',
  'portable fan',

  // Bathroom basics
  'bathroom amenities',
  'bath tub',
  'bathtub',
  'bathtub only',
  'bathtub/shower combination',
  'shower',
  'shower only',
  'separate tub and shower',
  'separate tub or shower',
  'separate toilet area',
  'water closet',
  'bidet',
  'bathroom telephone',
  'phone in bathroom',
  'grab bars in bathroom',
  'bathtub seat',
  'lighted makeup mirror',
  'sink in-room',
  'bathrobe',
  'slippers',
  'towels provided',
  'towels sheets',

  // Safety / basic room equipment
  'smoke detectors',
  'fire alarm',
  'fire alarm with light',
  'weight scale',

  // Bed / linens
  'king bed',
  'queen bed',
  'twin bed',
  'double beds',
  'single bed',
  'full bed',
  'round bed',
  'bedding type unknown or unspecified',
  'bed linen thread count',
  'duvet',
  'pillow top mattress',
  'pillow menu',
  'pillow type',
  'foam pillows',
  'down/feather pillows',
  'hypoallergenic bed',
  'hypoallergenic pillows',
  'luxury linen type',

  // Standard furniture / layout
  'desk',
  'desk with lamp',
  'desk with electrical outlet',
  'chair provided with desk',
  'large desk',
  'large work area',
  'sitting area',
  'sitting area with sofa/chair',
  'sofa bed',
  'recliner',
  'tables and chairs',
  'dining room seats',
  'separate closet',
  'closets in room',
  'storage space',
  'walk-in closet',
  'multiple closets',
  'room windows open',

  // Kitchen / food prep
  'coffee/tea',
  'coffee/tea maker',
  'coffee',
  'tea',
  'bottled water',
  'kitchenette',
  'kitchen',
  'full kitchen',
  'kitchen supplies',
  'microwave',
  'dishwasher',
  'refrigerator',
  'mini-refrigerator',
  'refrigerator with ice maker',
  'freezer',
  'ice maker',
  'oven',
  'stove',
  'toaster',
  'toaster oven',
  'cookware, dishware, and utensils',
  'pots and pans',
  'plates and bowls',
  'plates/glassware',
  'cups/glassware',
  'silverware/utensils',
  'pantry',
  'electric kettle',

  // Storage / laundry
  'laundry basket',
  'laundry basket/clothes hamper',
  'washer/dryer',
  'washing machine',
  'dryer',
  'cleaning supplies',

  // Safety / convenience
  'safe',
  'in-room safe',
  'in room safe',
  'safe large enough to accommodate a laptop',
  'iron',
  'ironing board',
  'trouser/pant press',
  'shoe polisher',

  // Telephony / calls
  'telephone',
  'phone',
  'cordless phone',
  'speaker phone',
  'data port',
  'analog data port',
  'telephone with data ports',
  'modem',
  'modem jack',
  'multi-line phone',
  'two-line phone',
  'telephones with message light',
  'telephone for hearing impaired',
  'voice mail',
  'wake-up calls',
  'local calls',
  'free local calls',
  'toll free calls',
  'free toll free calls',
  'credit card access calls',
  'free credit card access calls',
  'international calls',
  'long distance calls',
  'operator-assisted calls',
  'collect calls',
  'calling card calls',

  // Connectivity / office basics
  'computer',
  'laptop',
  'printer',
  'scanner',
  'copier',
  'fax machine',
  'pc hook-up in room',
  'office supplies',
  'notepads',
  'pens',

  // Generic flags / room types
  'non-smoking',
  'smoking',
  'accessible room',
  'annex room',
  'family/oversized room',
  'adjoining rooms',
  'connecting rooms',
  'loft',
  'private bathroom',
  'shared bathroom',

  // Operational items
  'onsite laundry',
  'complimentary self service laundry',
  'coin operated laundry',
  'room service',
  'room service - full menu',
  'room service - limited menu',
  'room service - limited hours',
  '24-hour room service',
  'parking',
  'free parking',
  'on-site parking',
  'off-site parking',
  'indoor parking',
  'outdoor parking',
  'long term parking',
  'recreational vehicle parking',
  'motorcycle parking',
  'truck parking',
  'bus parking',
  'parking lot',
  'parking deck',
  'street side parking',
  'hairdryer',
  'elevators',
  'housekeeping - daily',
  'housekeeping - weekly',
  'baby sitting',
];

export const highSignalAmenityKeywords = [
  'complimentary breakfast',
  'complimentary wireless internet',
  'express check-in',
  'express check-out',
  'early check-in',
  'early check in guarantee',
  'late check-out',
  'late check-out available',
  'late check out guarantee',
  '24-hour front desk',
  'free one way airport transfer',
  'airport shuttle',
  'airport shuttle service',
  'room upgrade confirmed',
  'room upgrade',
  'room upgrade on availability',
  'complimentary buffet breakfast',
  'complimentary full american breakfast',
  'complimentary continental breakfast',
  'hot breakfast',
  'buffet breakfast',
  'full american breakfast',
  'continental breakfast',
  'hot continental breakfast',
  'deluxe continental breakfast',
  'meal included - breakfast',
  'meal included: full american breakfast',
  'meal included - continental breakfast',
  'all-inclusive meal plan',
  'full meal plan',
  'meal included - dinner',
  'meal included - lunch',
  'restaurant',
  'restaurant voucher - 100 usd',
  'restaurant voucher - 100 eur',
  'food and beverage discount',
  "children's breakfast",
  'carryout breakfast',
  'complimentary in-room coffee or tea',
  'complimentary coffee in lobby',
  'lobby coffee service',
  'coffee lounge',
  'free minibar',
  'minibar included',
  'evening reception',
  'managers reception',
  'social hour',
  'grocery shopping service available',
  'dinner delivery service from local restaurant',
  'complimentary cocktails',
  'baggage hold',
  'luggage service',
  'concierge',
  'concierge desk',
  'concierge breakfast',
  'club lounge',
  'executive lounge',
  'concierge lounge',
  'concierge floor',
  'butler service',
  'butler',
  'welcome amenity',
  'welcome drink',
  '24-hour security',
  'vip security',
  'turndown service',
  'valet cleaning',
  'valet same day dry cleaning',
  'complimentary newspaper delivered to room',
  'complimentary newspaper in lobby',
  'complimentary shoeshine',
  'translation services',
  'technical concierge',
  'currency exchange',
  'banking services',
  'pharmacy',
  'doctor on call',
  'medical facilities service',
  'cell phone rental',
  'boarding pass print-out available',
  'printing services available',
  'airline desk',
  'tour/sightseeing desk',
  'events ticket service',
  'theatre desk',
  'bottle of wine',
  'train station shuttle service',
  'theme park shuttle',
  'shuttle to local attractions',
  'shuttle to local businesses',
  'free transportation',
  'transportation services',
  'transportation services - local area',
  'transportation services - local office',
  'courtesy car',
  'car rental desk',
  'train access',
  'free airport parking',
  'secured parking',
  'valet parking',
  'free valet parking',
  'electric car charging station',
  'electric car charging stations',
  'limousine service',
  'limousine',
  'ferry',
  'helicopter service',
  'bicycle rentals',
  'full service spa',
  'spa access included',
  'spa',
  'fitness center',
  'gym',
  'exercise gym',
  'fitness club',
  'pool',
  'indoor pool',
  'outdoor pool',
  'heated pool',
  'hot tub',
  'whirlpool',
  'sauna',
  'steam bath',
  'massage services included',
  'massage services',
  'health and beauty services',
  'beauty shop/salon',
  'hairdresser/barber',
  'exercise equipment in room',
  'private pool',
  'poolside service',
  'poolside snack bar',
  'body scrub',
  'body wrap',
  'thalassotherapy',
  'solarium',
  'aerobics instruction',
  'jogging track',
  'sports trainer',
  'dietician',
  'private dining',
  'private dining for groups',
  'gourmet',
  'gourmet highlights',
  'halal food available',
  'kosher food available',
  'cocktail lounge',
  'cocktail lounge with light fare',
  'cocktail lounge with entertainment',
  'sports bar',
  'sports bar open for lunch',
  'sports bar open for dinner',
  'tapas bar',
  'café bar',
  'beach bar',
  'garden lounge bar',
  'beer garden',
  'outdoor summer bar/café',
  'communal bar area',
  'roof terrace',
  'summer terrace',
  'winter terrace',
  'private beach',
  'beachfront',
  'beach club',
  'golf access included',
  'golf',
  'driving range',
  'golf clubs (equipment)',
  'tennis court',
  'water sports',
  'game room',
  'live entertainment',
  'disney park tickets included',
  'water park passes included',
  'casino',
  'nightclub',
  'disco',
  'piano bar',
  'piano',
  'racquetball',
  'snow sports',
  'ski pass included',
  'free ski lift ticket & rental',
  'snow skiing',
  'water skiing',
  'horseback riding',
  'stables',
  'business center',
  'business services',
  'meeting rooms',
  'conference facilities',
  'business library',
  'secretarial service',
  'ballroom',
  'exhibition/convention floor',
  'office rental',
  'banquet facilities',
  'catering services',
  'wedding services',
  'executive floor',
  'semi-private space',
  'great room',
  'courtyard',
  'bbq/picnic area',
  'barbeque grills',
  'locker room',
  'children programs',
  'child programs',
  "children's play area",
  "children's nursery",
  'playground',
  'in room childcare',
  'pet friendly',
  'pets allowed',
  'pet amenities available',
  'pet-sitting services',
  'kennels',
  'same gender floor',
  'female traveler room/floor',
  'oceanfront',
  'ocean view',
  'beach view',
  'gulf view',
  'mountain view',
  'pool view',
  'balcony',
  'terrace',
  'lanai',
  'fireplace',
  'oversized bathtub',
  'private spa tub',
  'grecian tub',
  'plunge pool',
  'hinoki tub',
  'indoor private mineral hot springs',
  'honeymoon suites',
  'vip rooms',
  'tatami mats',
  'tatami (woven mat) floors',
  'smoke-free property',
  'all public areas non-smoking',
  'hypoallergenic rooms',
  'room air filtration',
  'water purification system in use',
  'eco friendly',
  'wheelchair access',
  'ada accessible',
  'accessible facilities',
  'accessible parking',
  'ramp access',
  'brailed elevators',
  'hearing impaired services',
  'cloakroom service',
  'atm/cash machine',
  'coffee shop',
  'multilingual staff',
  'gift/news stand',
  'dry cleaning',
  'laundry/valet service',
];

export default {
  baselineAmenityKeywords,
  highSignalAmenityKeywords,
};
